import MDReader from "./MDReader";
import WikiPageMenu from "./WikiPageMenu";

export default function WikiPage({ file, title, menu }) {
  return (
      <div className="wikipage">
          {menu && <WikiPageMenu menu={menu} />}
          <article className={title.toLowerCase() === 'downloads' ? 'downloads' : undefined}>
            <MDReader title={title} file={file} />
          </article>
      </div>
  );
}
